export default __webpack_public_path__ + "static/media/Giuria (1).94e94316.jpg";